import { useState } from "react";

import ProfileGeneral from "../../components/profile-general/profile-general.component";
import ProfileCloseAccount from "../../components/profile-close-account/profile-close-account.component";

const TABS = [
  { id: "general", label: "General", Panel: ProfileGeneral },
  { id: "close", label: "Close Account", Panel: ProfileCloseAccount },
];

const Profile = () => {
  const [currentTab, setCurrentTab] = useState(TABS[0].id);
  const ActivePanel = TABS.find((tab) => tab.id === currentTab).Panel;

  return (
    <>
      <p className="mb-5 text-sm text-gray-500">Your details and account settings.</p>

      <div className="flex flex-col gap-6 nav:flex-row nav:gap-8">
        {/* Tab rail on desktop, scrollable pills on a phone. */}
        <nav className="flex gap-1 overflow-x-auto border-b border-gray-200 pb-px nav:w-52 nav:flex-shrink-0 nav:flex-col nav:border-b-0 nav:pb-0">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setCurrentTab(tab.id)}
              aria-current={currentTab === tab.id ? "page" : undefined}
              className={`whitespace-nowrap px-4 py-2.5 text-sm font-medium transition nav:rounded-lg nav:text-left ${
                currentTab === tab.id
                  ? "border-b-2 border-primary-600 text-primary-700 nav:border-b-0 nav:bg-primary-50 nav:font-semibold"
                  : "border-b-2 border-transparent text-gray-500 hover:text-primary-700 nav:border-b-0 nav:hover:bg-gray-50"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        <div className="min-w-0 flex-1">
          <ActivePanel />
        </div>
      </div>
    </>
  );
};

export default Profile;
